import { render, staticRenderFns } from "./EmployeeAboutInfoReview.vue?vue&type=template&id=06f29a54"
import script from "./EmployeeAboutInfoReview.vue?vue&type=script&lang=js"
export * from "./EmployeeAboutInfoReview.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAboutInfoReview.vue?vue&type=style&index=0&id=06f29a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports